import deepLinkAttachmentRouteHandler, {
    deepLinkInternetMessageIdAttachmentRouteHandler,
} from './deepLinkAttachmentRouteHandler';
import { deepLinkMailModuleRouteHandler } from './deepLinkMailModuleRouteHandler';
import getCurrentDeepLinkRoute from './getCurrentDeepLinkRoute';
import { registerRoute as registerRouteFunction, RouterOptions } from 'owa-router';
import {
    deepLinkComposeRouteHandler,
    deepLinkReplyRouteHandler,
    deepLinkReplyAllRouteHandler,
} from './deepLinkComposeRouteHandler';

export let mailRouterOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentDeepLinkRoute),
    defaultRoute: '/deeplink',
};

export async function initializeDeepLinkMailRoutes(registerRoute: typeof registerRouteFunction) {
    registerRoute('/deeplink/read/:itemId', deepLinkMailModuleRouteHandler);
    registerRoute('/deeplink/readonly/:readonlyItemId', deepLinkMailModuleRouteHandler);
    registerRoute(
        '/deeplink/readimid/:base64EncodedInternetMessageId',
        deepLinkMailModuleRouteHandler
    );
    registerRoute('/deeplink/readconv/:convId', deepLinkMailModuleRouteHandler);
    registerRoute(
        '/deeplink/read/group/:groupDomain/:groupAlias/:itemId',
        deepLinkMailModuleRouteHandler
    );
    registerRoute(
        '/deeplink/readconv/group/:groupDomain/:groupAlias/:convId',
        deepLinkMailModuleRouteHandler
    );
    registerRoute('/deeplink/compose', deepLinkComposeRouteHandler);
    registerRoute('/deeplink/compose/reply', deepLinkReplyRouteHandler);
    registerRoute('/deeplink/compose/replyall', deepLinkReplyAllRouteHandler);
    registerRoute('/deeplink/compose/:draftId', deepLinkComposeRouteHandler);
    registerRoute(
        '/deeplink/internetmessageidattachment/:base64EncodedInternetMessageId/:attachmentIndex',
        deepLinkInternetMessageIdAttachmentRouteHandler
    );
    registerRoute(
        '/deeplink/attachment/:itemId/:attachmentId/:isEdit',
        deepLinkAttachmentRouteHandler
    );
    registerRoute('/deeplink/attachment/:itemId/:attachmentId', deepLinkAttachmentRouteHandler);
    // TODO: Remove additional deep link route after Group Card starts using new route
    registerRoute(
        '/deeplink/attachment/:itemId/:attachmentId/group/:groupDomain/:groupAlias',
        deepLinkAttachmentRouteHandler
    );
    registerRoute(
        '/deeplink/attachment/group/:groupDomain/:groupAlias/:itemId/:attachmentId',
        deepLinkAttachmentRouteHandler
    );

    registerRoute('/deeplink', deepLinkMailModuleRouteHandler);
}
